import React from 'react'
import { ICrosslinkCard as IContentfulCard } from 'marketing-site/@types/generated/contentful'
import { Card, IProps as ICard } from 'marketing-site/src/library/elements/Card'
import { transformCTAWithBackground } from 'marketing-site/src/transformers/elements/ContentfulCTALink'
import { transformAssetToImage } from 'marketing-site/src/transformers/elements/ContentfulImage'
import { getHexColorFromName } from 'marketing-site/src/library/utils'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

export const ContentfulCrosslinkCard = (crosslinkCard: IContentfulCard) => {
  return <Card {...transformCard(crosslinkCard)} />
}

export const transformCard = ({ sys, fields }: IContentfulCard): ICard => {
  return {
    ...fields,
    contentType: sys.contentType.sys.id,
    title: fields.title,
    body: fields.bodyText && documentToHtmlString(fields.bodyText),
    icon: fields.icon ? transformAssetToImage(fields.icon) : undefined,
    cta: fields.cta ? transformCTAWithBackground(fields.cta) : undefined,
    cardColor: getHexColorFromName(fields.cardColor),
    openMessenger: fields.openMessenger || false,
  }
}
